import { createFileRoute } from '@tanstack/react-router'
import { MachineEditor } from './-MachineEditor'

export const Route = createFileRoute('/packaging/machines/$id')({
  component: EditMachinePage,
})

function EditMachinePage() {
  const { id } = Route.useParams()
  return <MachineEditor id={id} />
}
